"use client";

import { useRef } from "react";
import PackageCard from "./PackageCard";
import styles from "./PackageSlider.module.css";

export default function PackageSlider({ packages }) {
  return (
    <div className={styles.wrapper}>
      

      <section className={styles.slider}>
        {packages.map((pkg, index) => (
          <PackageCard key={index} pkg={pkg} />
        ))}
      </section>
    </div>
  );
}